<template>
  <v-container fluid>
    <h1 class="mb-5">Nekilnojamojo turto sandoris</h1>
    <v-card class="pa-5">
      <template>
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(tipas, index) in tipasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkTipas(toggle, active, tipas)"
                  height="100%"
                  :elevation="active ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="tipas.icon"
                    :active="active"
                    type="sandoris"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ tipas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isTipas">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(veiksmas, index) in filterVeiksmasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkVeiksmas(toggle, active, veiksmas)"
                  height="100%"
                  :elevation="active && isVeiksmas ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="veiksmas.icon"
                    :active="active && isVeiksmas"
                    type="sandoris"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ veiksmas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isVeiksmas">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(potipis, index) in filterPotipisList"
              :key="index"
              cols="12"
              md="4"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :class="
                    'mx-auto potipis ' + (active && isPotipis ? 'active' : '')
                  "
                  @click="checkPotipis(toggle, active, potipis)"
                  height="100%"
                  :elevation="active && isPotipis ? '5' : '0'"
                >
                  <v-card-text :class="active && isPotipis ? 'active' : ''">
                    {{ potipis.title }}
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isVeiksmasContinued">
        <v-row align="baseline" class="mb-4">
          <v-col cols="12" md="4">
            <el-text-field
              label="Identifikavimo kodas (IDK)"
              v-model="searchKodas"
              idk
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-button @click.native="checkKodas()" :loading="loadingSearch"
              >Ieškoti</el-button
            >
          </v-col>
        </v-row>
      </template>
      <template v-if="isVeiksmasNew || isKodas">
        <v-row>
          <v-col cols="12" md="12">
            <h4>{{ sandorisTitle }}</h4>
          </v-col>
          <v-col cols="12" md="4">
            <el-button primary :loading="loadingKurti">{{
              sandorisButtonText
            }}</el-button>
          </v-col>
        </v-row>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'

export default {
  name: 'Sandoris',
  data() {
    return {
      potipis: null,
      veiksmas: null,
      tipas: null,
      objektas: null,
      searchKodas: 'LS200KO99',
      loadingSearch: false,
      loadingKurti: false,
      tipasList: [
        {
          key: 'sukurti',
          type: 'sukurti',
          title: 'Sukurti naują dokumentą',
          icon: 'mdi-home-edit-outline',
        },
        {
          key: 'registruoti',
          type: 'registruoti',
          title: 'Registruoti duomenis apie sandorį',
          icon: 'mdi-folder-home-outline',
        },
        {
          key: 'pagrindas',
          type: 'pagrindas',
          title: 'Sukurti dokumentą kito dokumento pagrindu',
          icon: 'mdi-home-city-outline',
        },
      ],
      veiksmasList: [
        {
          key: 'teikimas',
          type: 'sukurti registruoti pagrindas',
          title: 'Sutartys, kai keičiasi turto savininkas',
          icon: 'mdi-home-export-outline',
        },
        {
          key: 'pakeitimas',
          type: 'sukurti registruoti pagrindas',
          title:
            'Registruojami juridiniai faktai, kai nesikeičia turto savininkas',
          icon: 'mdi-home-outline',
        },
        {
          key: 'pabaiga',
          type: 'sukurti registruoti pagrindas',
          title:
            'Registruojamos daiktinės teisės, kai nesikeičia turto savininkas',
          icon: 'mdi-home-variant-outline',
        },
        {
          key: 'neisregistruoti',
          type: 'sukurti registruoti pagrindas',
          title: 'Sutartį lydintis dokumentas',
          icon: 'mdi-clipboard-text-multiple-outline',
        },
      ],
      potipisList: [
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Amalgamacijos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Aukos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Dovanojimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Išlaikymo iki gyvos galvos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Jungtinės veiklos (partnerystės) sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Kita sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Labdaros sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Mainų sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Nuomos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title:
            'Nuosavybės teisės liudijimas (notariato įstatymo 52 str. 1 d.)',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title:
            'Nuosavybės teisės liudijimas (notariato įstatymo 52 str. 2 d.)',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Nuosavybės teisių perleidimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Palikimo perėjimo valstybei liudijimas',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Paramos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Paveldėjimo teisės pagal įstatymą liudijimas',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Paveldėjimo teisės pagal testamentą liudijimas',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Paveldėto turto pasidalijimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Pirkimo - pardavimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Priėmimo - perdavimo aktas su lizingo bendrovėmis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Rentos sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Skolos padengimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Sutuoktinių turto pasidalijimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Turto atidalijimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Turto pasidalijimo sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Turto perleidimo už rentą sutartis',
        },
        {
          key: 'teikimas',
          type: 'teikimas',
          title: 'Turto sujungimo sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Amalgamacijos sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Hipotekos lakšto patvirtinimas',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Jungtinės veiklos (partnerystės) sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Kita sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Kito asmens turto administravimas',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Neatlygintinio naudojimo daiktu (panaudos) sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Nuomos sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Preliminarioji sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title:
            'Susitarimas dėl naudojimosi nekilnojamu daiktu tvarkos nustatymo',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Turto atidalijimo sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Turto pasidalijimo sutartis',
        },
        {
          key: 'pakeitimas',
          type: 'pakeitimas',
          title: 'Turto sujungimo sutartis',
        },

        {
          key: 'pabaiga',
          type: 'pabaiga',
          title: 'Ilgalaikės nuomos (emphyteusis) sutartis',
        },
        {
          key: 'pabaiga',
          type: 'pabaiga',
          title: 'Servituto sutartis',
        },
        {
          key: 'pabaiga',
          type: 'pabaiga',
          title: 'Turto patikėjimo teisės sutartis',
        },
        {
          key: 'pabaiga',
          type: 'pabaiga',
          title: 'Uzufrukto sutartis',
        },
        {
          key: 'pabaiga',
          type: 'pabaiga',
          title: 'Užstatymo teisės (superficies) sutartis',
        },

        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Liudijimas',
        },
        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Pakvitavimas',
        },
        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Pažyma dėl klaidos',
        },
        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Priėmimo – perdavimo aktas',
        },
        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Susitarimas nutraukti sutartį',
        },
        {
          key: 'neisregistruoti',
          type: 'neisregistruoti',
          title: 'Susitarimas pakeisti sutartį',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['objektasID']),

    filterVeiksmasList() {
      return this.veiksmasList.filter(veiksmas => {
        return veiksmas.type.includes(this.tipas.type)
      })
    },
    filterPotipisList() {
      return this.potipisList.filter(potipis => {
        return potipis.type.includes(this.veiksmas.key)
      })
    },
    isPotipis() {
      return this.potipis !== null
    },
    isVeiksmas() {
      return this.veiksmas !== null
    },
    isTipas() {
      return this.tipas !== null
    },
    isVeiksmasNew() {
      return this.combineType.includes('new')
    },
    isVeiksmasContinued() {
      return this.combineType.includes('continued')
    },
    combineType() {
      let type = ''
      this.tipas && (type += this.tipas.type)
      this.veiksmas && (type += ' ' + this.veiksmas.type)
      this.vykdomasis && (type += ' ' + this.vykdomasis.type)
      return type
    },
    isKodas() {
      return this.objektas && this.objektas.obj_identifikavimo_kodas !== null
    },
    sandorisButtonText() {
      return HipotekaMap['hipotekaTipas'][this.sandorisTipas].button
    },
    sandorisTitle() {
      return HipotekaMap['hipotekaTipas'][this.sandorisTipas].title
    },
    sandorisTipas() {
      return (
        (this.tipas ? this.tipas.key : '') +
        '-' +
        (this.veiksmas ? this.veiksmas.key : '')
      )
    },
  },
  methods: {
    checkPotipis(toggle, active, potipis) {
      this.potipis = potipis
      this.objektas = null
      if (!active) {
        toggle()
      }
    },
    checkVeiksmas(toggle, active, veiksmas) {
      this.veiksmas = veiksmas
      this.potipis = null
      this.objektas = null
      if (!active) {
        toggle()
      }
    },
    checkTipas(toggle, active, tipas) {
      this.tipas = tipas
      this.potipis = null
      this.veiksmas = null
      this.objektas = null
      if (!active) {
        toggle()
      }
    },
    checkKodas() {
      this.loadingSearch = true
      this.objektas = null
      this.$axios
        // .get(`objektas/search/${this.searchKodas}`)
        .get(`testok`)
        .then(res => {
          // this.objektas = res.data.objektas
          this.objektas = {
            obj_identifikavimo_kodas: '123',
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadingSearch = false
        })
    },
    sukurtisandoris() {
      this.loadingKurti = true
      this.$axios
        .post(`objektas`, {
          obj_tipas: this.sandorisTipas,
          obj_id: this.objektas ? this.objektas.obj_id : null,
        })
        .then(res => {
          this.$store.dispatch('objektasID', res.data.objektas.obj_id)
          this.$store.dispatch('sandorisTipas', this.sandorisTipas)
          this.$router.push({
            name: 'sandorisPranesimas',
            params: {
              objektasID: this.objektasID,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadingKurti = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693 !important;

  &.active {
    background: #2c7837 !important;
    .v-card__text {
      color: #fff;
    }
  }
}
</style>
